const initialState = {
  firmData:{},
    newFirm:true,
    existOnMaya:false,
    current: 0,
    loading:false
  };
  
export default function titleReducer  (state=initialState, action)  {
    switch (action.type) {
      case "TITLE_DATA_FETCHING":
        return {
          ...state,
          loading: true
        };
      case "SET_TITLE_DATA":
        return {
          ...state,
          loading: false,
          firmData: {user : action.payload.user, userFirm:action.payload.userFirm},
          existOnMaya: action.payload.existOnMaya,
          newFirm:false
        };
    case "SET_TITLE_CURRENT":
            return {
              ...state,
              current: action.payload
            };
    case "TITLE_DATA_FETCHED":
              return {
                ...state,
                loading: false
              };
    default:
        return state;
    }
  };